import { app } from '@/main';
import flagKeys from '@/constants/flagKeys';
import { EOnboardingMeetingStatus } from '@/models/onboarding-call';
import { IBusinessType } from '@/models/business';
import { getMerchantMeetingOboardingState } from '@/router/router-utils';

// The US onboarding relaunch hides every onboarding call surface, as the host
// does (TWISM-20348). Hidden, not removed: the call comes back after it, and
// every legacy gate below reads this one check so they come back together.
export const isOnboardingCallHidden = () => {
  const flags = app.$store.getters['flags/getFlags'] || [];

  return flags.includes(flagKeys.usOnboardingRelaunch);
};

// Also hides the landing page link and swaps the billing copy to "waiting for
// profile activation". The API no longer creates the PENDING billing hold
// that copy describes, so nothing waits on the call with it hidden.
export const getNeedsOnboardingCall = () => {
  const flags = app.$store.getters['flags/getFlags'] || [];
  const business = app.$store.getters['business/getBusinessInfo'].business;

  return !!(
    flags.includes(flagKeys.showOnboardingCallBanner) &&
    !isOnboardingCallHidden() &&
    business &&
    business.onboardingMeeting &&
    business.onboardingMeeting.status !== EOnboardingMeetingStatus.COMPLETED
  );
};

export const getShowOnboardingCallBanner = () => {
  const flags = app.$store.getters['flags/getFlags'] || [];
  const business = app.$store.getters['business/getBusinessInfo'].business;

  return !!(
    flags.includes(flagKeys.showOnboardingCallBanner) &&
    !isOnboardingCallHidden() &&
    business &&
    [IBusinessType.INSTORE, IBusinessType.BOTH].includes(business.type) &&
    (getMerchantMeetingOboardingState() ||
      (business.onboardingMeeting &&
        !business.onboardingMeeting.isConfirmedBannerViewed))
  );
};
